import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12085c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-exam-header-container" }
const _hoisted_2 = { class: "header-tip-container-box" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "paper-info-box"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "paper-info-title" }, "答卷ID：", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "paper-info-title" }, "试卷总分：", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "paper-info-title" }, "共耗时：", -1))
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "paper-info-title" }, "答题时间：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回试卷", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "作品介绍", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "交卷", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTip = _resolveComponent("HeaderTip")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_Countdown = _resolveComponent("Countdown")!
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_SendOutlined = _resolveComponent("SendOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_WorkProfileDialog = _resolveComponent("WorkProfileDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderTip, { tip: _ctx.tip }, null, 8, ["tip"])
    ]),
    _createVNode(_component_a_row, { type: "flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { flex: "auto" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass([
            _ctx.examService.answerPaperInfo ? 'exam-full-width' : 'exam-name-text',
          ])
            }, [
              _createElementVNode("span", {
                title: _ctx.examService.exam.examName
              }, _toDisplayString(_ctx.examService.exam.examName), 9, _hoisted_3),
              (_ctx.examService.answerPaperInfo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    (_ctx.examService.answerPaperInfo.answerPaperId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", null, _toDisplayString(_ctx.examService.answerPaperInfo.answerPaperId), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.examService.answerPaperInfo.userTotalScore >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.examService.answerPaperInfo.userTotalScore) + "分", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.examService.answerPaperInfo.costTime >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.examService.answerPaperInfo.costTime / 60)) + "分钟", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.examService.answerPaperInfo.beginAnswerTime)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDateToSecond(
                    _ctx.examService.answerPaperInfo.beginAnswerTime
                  )) + "-" + _toDisplayString(_ctx.formatDateToSecond(
                    _ctx.examService.answerPaperInfo.commitAnswerTime
                  )), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2), [
              [_vShow, !_ctx.questionService.showIde]
            ]),
            _withDirectives(_createVNode(_component_a_button, {
              class: "btn-blue",
              type: "default",
              shape: "round",
              size: "large",
              onClick: _ctx.onHideIde
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_LeftOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [_vShow, _ctx.questionService.showIde]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { flex: "450px" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { justify: "end" }, {
              default: _withCtx(() => [
                (!_ctx.examService.answerMode)
                  ? (_openBlock(), _createBlock(_component_a_col, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Countdown, {
                          title: "剩余时间：",
                          time: _ctx.countdownService.remainTime
                        }, null, 8, ["time"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      class: "btn-orange ml15",
                      type: "default",
                      shape: "round",
                      size: "large",
                      onClick: _ctx.questionService.showWorkProfileDialog
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_FileTextOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, 
              _ctx.questionService.showIde && _ctx.questionService.isProgramCreation
            ]
                ]),
                _withDirectives(_createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      class: "btn-orange ml15",
                      type: "default",
                      shape: "round",
                      size: "large",
                      onClick: _ctx.onManualSubmitExam
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_SendOutlined, {
                          rotate: -45,
                          style: {"transform-origin":"30%","font-size":"14px"}
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.questionService.showIde && !_ctx.examService.answerMode]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_WorkProfileDialog)
  ]))
}